export const authTokenKeyName = 'authToken';
export const refreshTokenKeyName = 'refresh_token';
